import React from "react";
import { useTranslation } from "react-i18next";
import { getCurrentDemoConfig } from "../../config/demoSites";

interface WorkflowStepsProps {
    currentStep: number;
    onStepChange: (step: number) => void;
}

const WorkflowSteps: React.FC<WorkflowStepsProps> = ({ currentStep, onStepChange }) => {
    const { t } = useTranslation();
    const demoConfig = getCurrentDemoConfig();

    // Get steps from demo configuration
    const steps = demoConfig.steps.map(step => ({
        id: step.id,
        key: step.key,
        title: t(`${demoConfig.name}.workflow.steps.${step.key.toLowerCase()}.title`, step.key)
    }));

    return (
        <div className="flex flex-nowrap items-center justify-around overflow-x-auto border-b border-gray-200 pb-4">
            {steps.map(step => (
                <div
                    key={step.id}
                    onClick={() => onStepChange(step.id)}
                    className={`flex cursor-pointer flex-col items-center px-4 ${currentStep === step.id ? "text-primary" : "text-gray-500"} `}
                >
                    <div
                        className={`mb-2 flex h-8 w-8 items-center justify-center rounded-full ${
                            currentStep === step.id ? "bg-primary text-white" : currentStep > step.id ? "bg-green-500 text-white" : "bg-gray-200 text-gray-600"
                        } `}
                    >
                        {currentStep > step.id ? "✓" : step.id}
                    </div>
                    <div className={`text-sm ${currentStep === step.id ? "font-medium" : ""}`}>{step.title}</div>
                </div>
            ))}
        </div>
    );
};

export default WorkflowSteps;
